export default "__VITE_ASSET__CDJIZgAO__"